import type {
  AcceptedAccountPropertyQueryParams,
  QuickFilterType,
} from '@/hooks/useAccountProperties';
import type { TypedTransformConfig } from '@/hooks/useUrlState';

export const DEFAULT_URL_STATE_VALUES = {
  page: {
    fromUrl: Number,
    defaultValue: 1,
  },
  limit: {
    fromUrl: Number,
    defaultValue: 50,
  },
  search: {
    fromUrl: String,
    defaultValue: '',
  },
  quickFilter: {
    fromUrl: (value: QuickFilterType) => value,
    defaultValue: 'none' as const,
  },
  assignedTo: {
    fromUrl: String,
    defaultValue: '',
  },
  pmc: {
    fromUrl: String,
    defaultValue: '',
  },
  pmcName: {
    fromUrl: String,
    defaultValue: '',
  },
} as const satisfies TypedTransformConfig<AcceptedAccountPropertyQueryParams>;

export const MAX_PAGINATION_LIMIT = 250;
